import { TranslocoService } from '@ngneat/transloco';
import { StatusTagConfiguration } from '@platform-frontend/ui-tools';
import { CANCELED_STATUS_TAG_CONFIGURATION } from './canceled-status-tag-configuration';
import { EXPIRED_STATUS_TAG_CONFIGURATION } from './expired-status-tag-configuration';
import { FullOneTimePurchaseBookingStatus } from './full-one-time-purchase-booking-status';
import { ONE_TIME_PURCHASE_BOOKING_STATUS_TAG_CONFIGURATIONS } from './one-time-purchase-booking-status-tag-configurations';

export const FULL_ONE_TIME_PURCHASE_BOOKING_STATUS_TAG_CONFIGURATIONS: (
  translocoService: TranslocoService
) => StatusTagConfiguration<FullOneTimePurchaseBookingStatus>[] = (translocoService: TranslocoService) => [
  ...ONE_TIME_PURCHASE_BOOKING_STATUS_TAG_CONFIGURATIONS(translocoService),
  EXPIRED_STATUS_TAG_CONFIGURATION(translocoService),
  CANCELED_STATUS_TAG_CONFIGURATION(translocoService)
];
